import { useState } from 'react'
import Grid from '@mui/joy/Grid'
import Sheet from '@mui/joy/Sheet'
import Divider from '@mui/joy/Divider'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import { CanvasContainer } from './CanvasContainer'
import { AdminLayerManager } from './AdminLayerManager'
import { Canvas } from './ui/CanvasV2'
import { AdminObjectPanel } from './AdminObjectPanel'
import { ErrorAlert } from './ui/ErrorAlert'

const SQUARE_TEMPLATE_SIZE = 600
export const AssetEditor = ({ canvasJSON, onSave, onExit, errorMsg }) => {
    const [dimensions, setDimensions] = useState({
        width: SQUARE_TEMPLATE_SIZE,
        height: SQUARE_TEMPLATE_SIZE,
        scale: 1,
    })
    const [canvas, setCanvas] = useState(canvasJSON ? canvasJSON : null)
    const [layers, setLayers] = useState([])
    const [selected, setSelected] = useState(null)

    const handleLayersChange = (e) => {
        // MUST FIX: currently using _objects (private member) because toJSON nukes internal metadata attached to objects on addition to the canvas (i.e. id).
        // To properly serialize data you need to make id a deserializable property by declaring it in the class funcs.
        setLayers([...e.target.canvas._objects])
    }

    const handleSelection = ({ selected }) => {
        console.log('selection')
        setSelected(selected[0])
    }

    const handleSelectionCleared = () => {
        console.log('cleared')
        setSelected(null)
    }

    return (
        <Grid container direction="row" sx={{ height: `calc(100vh - 3.5rem)` }}>
            <Grid xs={2.75}>
                <Sheet
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexGrow: 1,
                        flexDirection: 'column',
                        gap: 2,
                        borderWidth: '0 1px 0 0',
                    }}
                    variant="outlined"
                    color="neutral"
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            m: 2,
                            gap: 2,
                        }}
                    >
                        <Button
                            color="primary"
                            size="lg"
                            onClick={() => onSave(canvas)}
                        >
                            Save Template
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="lg"
                            onClick={onExit}
                        >
                            Exit
                        </Button>
                    </Box>
                    <Divider />
                    <Box sx={{ ml: 2, mr: 2 }}>
                        <AdminLayerManager
                            canvas={canvas}
                            layers={layers}
                            selected={selected}
                        />
                    </Box>
                    <Divider />
                </Sheet>
            </Grid>
            <Grid xs={6.5} direction="column">
                {errorMsg && (
                    <Box sx={{ m: 2 }}>
                        <ErrorAlert>{errorMsg}</ErrorAlert>
                    </Box>
                )}
                <Sheet
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexGrow: 1,
                        flexDirection: 'row',
                        borderWidth: '0 1px 0 0',
                    }}
                    variant="outlined"
                    color="neutral"
                >
                    <CanvasContainer
                        fillPercentage={80}
                        originalWidth={SQUARE_TEMPLATE_SIZE}
                        originalHeight={SQUARE_TEMPLATE_SIZE}
                        onResize={(data) => setDimensions(data)}
                    >
                        <Canvas
                            width={dimensions.width}
                            height={dimensions.height}
                            scale={dimensions.scale}
                            onObjectAdded={handleLayersChange}
                            onObjectModified={handleLayersChange}
                            onObjectRemoved={handleLayersChange}
                            onSelectionCreated={handleSelection}
                            onSelectionUpdated={handleSelection}
                            onSelectionCleared={handleSelectionCleared}
                            canvasJSON={canvasJSON}
                            ref={(canvas) => setCanvas(canvas)}
                        />
                    </CanvasContainer>
                </Sheet>
            </Grid>
            <Grid xs={2.75}>
                <Sheet
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexGrow: 1,
                        flexDirection: 'row',
                    }}
                    color="neutral"
                >
                    <AdminObjectPanel
                        canvas={canvas}
                        obj={selected}
                        onChange={() => {}}
                        onDelete={() => {}}
                    />
                </Sheet>
            </Grid>
        </Grid>
    )
}
